import { Injectable } from "@angular/core";
import { OauthHelper } from "./webservice/oauth-helper.service";
import { JwtHelper } from "angular2-jwt";

@Injectable()
export class RoleService {
	constructor(private oauthHelper: OauthHelper, private jwtHelper: JwtHelper) {
	}

	public hasUserRoles(roles) {
		let _roles: string[] = roles.replace(/\s+/g, '').split(',')
		let decodedToken = this.jwtHelper.decodeToken(this.oauthHelper.getAccessToken());
		let springRoles = _roles.map(roleName => ("ROLE_" + roleName));
		if (springRoles.every(role => decodedToken.authorities.indexOf(role) !== -1)) {
			return true
		}
		return false
	};
}




// WEBPACK FOOTER //
// ./src/app/services/role.service.ts